import 'client-only';

import { useCallback, useEffect, useState } from 'react';

export const useLocationHash = () => {
  const [hash, setHash] = useState('');

  useEffect(() => {
    setHash(window.location.hash);

    const updateHash = () => setHash(window.location.hash);

    window.addEventListener('hashchange', updateHash);
    return () => window.removeEventListener('hashchange', updateHash);
  }, []);

  const setWindowHash = useCallback((newHash: string) => {
    window.location.hash = newHash;
  }, []);

  return {
    hash,
    setHash: setWindowHash,
  };
};
